import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Table, Tag } from "antd";
// REDUX
import { useSelector } from "react-redux";
// UTILS
import { getTableRowClass } from "../../../utils/utils";
// INTERFACES
import { RootState } from "../../../app/store";

export default function KeysConfirmSaveTableData({ data, componentType }: any) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Column } = Table;
	const EXCLUDE_KEYS = [
		"isValid",
		"idMessage",
		"idKey",
		"id",
		"idMessageType",
		"created_at",
		"updated_at",
		"deleted_at",
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [validData, setValidData] = useState<any>([]);
	const [keysToColumns, setKeytsToColumns] = useState<any>([]);
	const [totalRows, setTotalRows] = useState<number>(0);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const formatTableTitle = (key: string): string => {
		let formatted = key.replace(/_/g, " ");

		formatted = formatted.replace(/([a-z])([A-Z])/g, "$1 $2");

		formatted = formatted.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

		return formatted;
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (componentType === "offsets" || componentType === "keys") {
			const flag = componentType === "actions" ? "active" : "isValid";

			const validItems = data.filter((item: any) => Boolean(item?.[flag]));
			setValidData(validItems);
			setTotalRows(validItems.length);

			const first = validItems[0] ?? {};
			const keys = Object.keys(first).filter((k) => !EXCLUDE_KEYS.includes(k));
			setKeytsToColumns(keys);
		}
	}, [data]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Table
			locale={{
				emptyText: (
					<div className='generalStyles__flexCenter' style={{ height: "300px" }}>
						No Data
					</div>
				),
			}}
			rowClassName={(record, index) => getTableRowClass(index, theme)}
			dataSource={validData}
			pagination={false}
			rowKey={(record) => record.idMessage}
			size='small'
			className='mt-3'
			footer={() => (
				<div className='generalStyles__flexEnd'>
					<Tag>{totalRows} Rows</Tag>
				</div>
			)}
		>
			{keysToColumns.map((key: any) => (
				<Column key={key} title={formatTableTitle(key)} dataIndex={key} render={(value) => <>{String(value)}</>} />
			))}{" "}
		</Table>
	);
}
